<div class="w-full rounded-md border border-stroke-100 bg-gray-000 p-2" data-cy="symbol-message-card">
	<div class="flex items-center gap-1.5">
		<ui-icon width="16" height="16" class="shrink-0 text-gray-500" aria-hidden="true" [iconName]="IconName.Clock" />

		<span class="text-xs font-medium text-gray-500 tabular-nums" data-cy="symbol-message-card-time">
			{{ message().time }}
		</span>
	</div>

	<!--
		`line-clamp-2` rather than a truncated string: the ellipsis then lands wherever the
		rendered second line actually ends, at any width and font size, and the whole body
		is in the DOM the entire time — so expanding is a class change, not a re-render.
	-->
	<p
		#body
		class="m-0 mt-1 text-start text-xs font-medium leading-5 text-gray-900"
		data-cy="symbol-message-card-description"
		[id]="bodyId"
		[class.line-clamp-2]="!expanded()">
		{{ message().description }}
	</p>

	@if (clamped()) {
		<div class="mt-1 flex items-center justify-center">
			<ui-button
				variant="ghost"
				size="sm"
				data-cy="symbol-message-card-toggle"
				[attr.aria-controls]="bodyId"
				[attr.aria-expanded]="expanded()"
				(clicked)="toggle()">
				<ui-icon
					leftIcon
					width="16"
					height="16"
					class="shrink-0 text-blue-500 transition-transform duration-300 ease-in-out"
					[iconName]="IconName.ChevronDown"
					[class.rotate-180]="expanded()" />
				<span class="text-blue-500">{{ toggleLabel() }}</span>
			</ui-button>
		</div>
	}
</div>
